import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllCourses extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Course/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
class CreateACourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Course/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}
class DeleteACourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Course/DeleteBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
class GetACourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Course/GetBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
class UpdateACourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Course/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}
export {
  GetAllCourses,
  CreateACourse,
  DeleteACourse,
  GetACourse,
  UpdateACourse,
};
